import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import { useSearchParams } from 'react-router-dom';

export default function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ category: '', organic: false });
  const [sortOrder, setSortOrder] = useState('random');
  const [searchParams] = useSearchParams();
  const producerId = searchParams.get('producer');
console.log('Producer ID from URL:', producerId); // Debug

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        if (filters.category) params.append('category', filters.category);
        if (filters.organic) params.append('organic', 'true');
        if (producerId) params.append('producer', producerId);
        if (sortOrder) params.append('sort', sortOrder);

        const response = await fetch(`/api/products?${params.toString()}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!response.ok) throw new Error('Failed to fetch');
        const data = await response.json();
        setProducts(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [filters, sortOrder, producerId]);

  const categories = ['vegetables', 'fruits', 'dairy', 'meat', 'eggs', 'honey', 'livestock', 'other'];

  if (loading) return <div className="text-center py-8">Loading products...</div>;
  if (error) return <div className="text-center py-8 text-red-600">Error: {error}</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Fresh Products</h1>
        <div className="flex items-center gap-2">
          <label className="text-sm text-gray-600">Sort by:</label>
          <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} className="border rounded px-2 py-1 text-sm">
            <option value="random">Random</option>
            <option value="newest">Newest First</option>
          </select>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-lg shadow-md">
        <div className="flex flex-wrap gap-4">
          <select value={filters.category} onChange={(e) => setFilters({ ...filters, category: e.target.value })} className="px-4 py-2 border rounded-md">
            <option value="">All Categories</option>
            {categories.map(cat => <option key={cat} value={cat}>{cat.charAt(0).toUpperCase() + cat.slice(1)}</option>)}
          </select>
          <label className="flex items-center space-x-2">
            <input type="checkbox" checked={filters.organic} onChange={(e) => setFilters({ ...filters, organic: e.target.checked })} className="rounded" />
            <span>Organic Only</span>
          </label>
        </div>
      </div>

      {/* Products Grid */}
      {products.length === 0 ? (
        <div className="text-center py-12"><p className="text-gray-500">No products found</p></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map(product => <ProductCard key={product._id} product={product} />)}
        </div>
      )}
    </div>
  );
}
